import axios from "../utils/axios";

export async function getClipFilterOptions(searchOptions){
    const response = await axios.post(`clip/v2/filterOptions`, {searchOptions});
    return response.data
}

export async function getClipCollectionFilterOptions(){
    const response = await axios.post(`clip/v2/collection/filterOptions`);
    return response.data
}

export async function updateClipCollection(collectionId, body){
    const response = await axios.put(`clip/v2/collection/${collectionId}`, body)
    return response.data
}

export async function deleteClipCollection(collectionId){
    const response = await axios.delete(`clip/v2/collection/${collectionId}`)
    return response.data
}

export async function deleteLogicClip(logicClipId){
    const response = await axios.delete(`clip/${logicClipId}`);
    return response.data
}

export async function createClipCollection(body){
    const response = await axios.post(`clip/v2/collection`, body)
    return response.data
}

export async function getClipById(id) {
    const response = await axios.get(`clip/${id}`);
    return response.data
}

export async function getClipId(id){
    const response = await axios.get(`clip/v2/clip/${id}`)
    return response.data
}

export async function getClipKeyMoments(clipId){
    const response = await axios.get(`clip/v2/${clipId}/key_moments`);
    return response.data
}

export async function updateLogicClip(logicClipId, logicClip){
    const response = await axios.put(`clip/v2/logic_clip/${logicClipId}`, logicClip);
    return response.data
}

export async function getClipCollectionById(collectionId) {
    const response = await axios.get(`clip/v2/collections/${collectionId}`);
    return response.data
}

export async function updateSimpleLogicClip(logicClipId, body) {
    const response = await axios.put(`clip/v2/logic_clip_simple/${logicClipId}`, body)
    return response.data
}

export async function createLogicClip(logicClip){
    const response = await axios.post(`clip/v2/logic_clip`, logicClip);
    return response.data
}

export async function getClipsKeyMomentByIds(clipIds, needCards){
    const response = await axios.post(`clip/v2/clips_key_moments_by_ids`, {clipIds, needCards});
    return response.data
}

export async function materializeLogicClip(logicClipId, materializationSettings, background = true){
    materializationSettings.aspectRatio = parseInt(materializationSettings.aspectRatio.split(":")[0])/parseInt(materializationSettings.aspectRatio.split(":")[1])
    const response = await axios.post(`clip/v2/logic_clip/materialize/${logicClipId}`, {...materializationSettings, background});
    return response.data
}

function getRequestCreationSettings(productionSettings, suggestSettings){
    return {
        ...productionSettings,
        suggest_params: suggestSettings
    }
}

export async function saveClipCards(clipCards, name, productionSettings, suggestSettings, audioTrack, keyMomentFilters){
    let creation_settings = getRequestCreationSettings(productionSettings, suggestSettings);
    try{
        if (creation_settings && creation_settings.interleave) {
            creation_settings.interleave = creation_settings.interleave.sort((a, b) => {
                return a.params.data.number - b.params.data.number;
            });
        }
    }catch(error) {}
    const response = await axios.post(`clip/v2/saveCards`, {
        name,
        collectionClips: clipCards,
        creation_settings,
        audio_type: audioTrack,
        km_filter: keyMomentFilters
    });
    return response.data
}

export async function updateClipCards(logicClipId, clipCards, name, productionSettings, suggestSettings, audioTrack, keyMomentFilters){
    let creation_settings = getRequestCreationSettings(productionSettings, suggestSettings);
    try{
        if (creation_settings && creation_settings.interleave) {
            creation_settings.interleave = creation_settings.interleave.sort((a, b) => {
                return a.params.data.number - b.params.data.number;
            });
        }
    }catch(error) {}
    const response = await axios.put(`clip/v2/updateCards/${logicClipId}`,
        {
            name,
            collectionClips: clipCards,
            creation_settings,
            audio_type: audioTrack,
            km_filter: keyMomentFilters
        });
    return response.data
}

export async function getLogicKeyMomentsAsCards(logicClipId){
    const response = await axios.get(`clip/v2/panel_logic_clip/${logicClipId}`);
    return response.data
}

export async function getAutomaticCollectionsByEvent(eventId) {
    const response = await axios.get(`clip/v2/automaticCollections/event/${eventId}`);
    // API returns { data: [...], total: null } — unwrap the inner array
    return Array.isArray(response.data) ? response.data : (response.data?.data ?? []);
}

export async function publishLogicClipMaterialization(materializationId, publishSetting, create_draft = false){
    const response = await axios.post(`clip/v2/logic_clip_materialization_publish/${materializationId}`, publishSetting, {params: {create_draft}})
    return response.data
}

export async function getLogicClipPublications(logicClipId, abortController){
    const response = abortController ? await axios.get(`clip/v2/logic_clip_publications/${logicClipId}`, {signal: abortController.signal}) : await axios.get(`clip/v2/logic_clip_publications/${logicClipId}`)
    return response.data
}

export async function generateClipLogicDescription(logicClipId, language, style){
    const response = await axios.post(`clip/v2/generate_logic_clip_descriptions/${logicClipId}`, {styles: [style], languages: [language]})
    const description = response.data[0]
    return (description ? {style, language, description: description.description} : {style, language, description: ''})
}

export async function generateClipLogicDescriptions(logicClipId, languages, styles){
    const response = await axios.post(`clip/v2/generate_logic_clip_descriptions/${logicClipId}`, {styles, languages})
    return response.data
}
